const oevb = {
  siegel: [],
  produktvergleich: {
    links: {
      leistungsuebersichtLink: 'https://www.oevb.de/hausrat_leistungsuebersicht',
      infoBlattLink: 'https://www.oevb.de/hausrat_produktinformation',
      infoBlattGlasLink: 'https://www.oevb.de/haushalt_glas_produktinformation',
      versBedingungenLink: 'https://www.oevb.de/hausrat_versicherungsbedingungen',
      versBedingungenGlasLink: 'https://www.oevb.de/haushalt_glas_versicherungsbedingungen',
    },
  },
};

export default oevb;
